import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router';
import { getImages } from '../../Component/const';
import SendForm from '../../Component/Chat/SendForm';
import ChatLayout from '../../Component/Chat/ChatLayout';
import ChatList from '../../Component/Chat/ChatList';
import ChatBoxHeader from '../../Component/Chat/ChatBoxHeader';
import ChatGroupList from '../../Component/Chat/ChatGroupList';
import ChatNewList from '../../Component/Chat/ChatNewList';
import ModalLayout from '../../Component/Common/ModalLayout';
import PhotosUpload from '../../Component/Common/PhotosUpload';
import HistoricalOptionsModal from '../../Component/Common/HistoricalOptionsModal';
import { ChatContext } from '../../Component/Context/ChatContext';

const Chat = () => {
    const [chatOpen, setChatOpen] = useState(false);

    const [photoSIDs,setPhotoSIDs] = useState([]);

    const {listAllMessages, chatList,convoData,initiateConvo,sendMessage, activeChatData, openChat} = useContext(ChatContext);

    const containerRef = useRef(null);

    useEffect(() => {
        listAllMessages();
    })

    useEffect(() => {
        const element = containerRef.current;

        if (element) {
            setTimeout(function () {
                element.scrollIntoView({ behavior: 'smooth' });
            }, 500);
        }
    }, [activeChatData]);

    useEffect(() => {
        console.log("photos changed",photoSIDs);
    },[photoSIDs]);

    const createChat = (chat_data) => {
        console.log(chat_data);

        initiateConvo(chat_data);
    }

    const backArrowBtn = () => {
        setChatOpen(false);
    };

    const { state } = useLocation();

    /*const sendMessage = (message) => {
        console.log('Sending message:', message);
        if (message && activeChatData) {
            // Logic for handling message send (e.g., updating state)
        }
    };*/

    // 
    const queryParameters = new URLSearchParams(window.location.search)
    const new_chat = queryParameters.get("new_chat");
    const new_group = queryParameters.get("new_group");
    const [newChat, setNewChat] = useState(new_chat !== null ? true : false);
    const [newGroup, setNewGroup] = useState(new_group !== null ? true : false);
    const [groupChatNames, setGroupChatNames] = useState([]);
    const [groupChat, setGroupChat] = useState({ messages: [] });
    const [groupName, setGroupName] = useState('');
    const setGroupChatName = () => {
        console.log(groupName);
        if (groupName) {
            var groupChats = groupChat;
            groupChats.messages = [];
            groupChats.name = groupName;
            setGroupChat(groupChats);
        }
        setGroupName('');
    }

    
    // Photo Upload Modal
    const [openPhotoUploadModal, setOpenPhotoUploadModal] = useState(false);
    const handlePhotoUploadModal = () => {
        setOpenPhotoUploadModal(true);
        document.body.classList.add('overflow-body');
    }
    const closePhotoUploadModal = () => {
        setOpenPhotoUploadModal(false);
        document.body.classList.remove('overflow-body');
    }

    // Historical Options Modal
    const [openHistoricalOptionsModal, setOpenHistoricalOptionsModal] = useState(false);
    const handleHistoricalOptionsModal = () => {
        setOpenHistoricalOptionsModal(true);
        document.body.classList.add('overflow-body');
    }
    const closeHistoricalOptionsModal = () => {
        setOpenHistoricalOptionsModal(false);
        document.body.classList.remove('overflow-body');
    }

    // Enter Message
    const [openEnterMessage, setOpenEnterMessage] = useState(false);
    const handleEnterMessage = () => {
        setOpenEnterMessage(!openEnterMessage)
    }
    return (
        <>
            <ChatLayout>
                {newChat ?
                    (<>
                        <ChatNewList
                            createChat={createChat}
                            chatList={chatList}
                            setNewChat={setNewChat}
                        />
                    </>) :
                    (newGroup ?
                        (<>
                            <ChatGroupList
                                chatList={chatList}
                                setGroupName={setGroupName}
                                groupName={groupName}
                                setNewGroup={setNewGroup}
                                createChat={createChat}
                            />
                        </>)
                        :
                        (<>
                            <ChatList
                                openChat={openChat}
                                convoData={convoData}
                                setNewGroup={setNewGroup}
                                setNewChat={setNewChat}
                            />
                        </>)
                    )}
                {activeChatData && <div className="chatbox">
                    <div className="modal-dialog-scrollable">
                        <div className="modal-content">
                            <ChatBoxHeader
                                chatHeader={activeChatData && activeChatData.friendly_name}
                                backArrowBtn={backArrowBtn}
                                chatName={groupChatNames}
                            />
                            <div className="modal-body p-0" >
                                {activeChatData && activeChatData.current_messages && activeChatData.current_messages.map((v,i) => 
                                    {
                                        
                                        return (
                                            <div className="msg-body" key={i}>
                                                <ul>
                                                    {(i == 0 || activeChatData.current_messages[i-1].relative_day != v.relative_day) && <li className='text-center mb-3'>
                                                        <div className='msg-day d-inline-block'>{v.relative_day}</div>
                                                    </li>}
                                                    <li className="sender">
                                                        <div className='msg-box'>
                                                            <div className='d-flex align-items-center justify-content-between mb-3'>
                                                                <div className='sm-title fw-600'>{v.body}</div>
                                                                <span className='xs-title font-12'>{v.message_time}</span>
                                                            </div>
                                                            {v.media && v.media.length > 0 && <div className='mt-3 d-flex align-items-center chat-gallery'>
                                                                <div className='cg-col'>
                                                                    {v.media.map((v,i) => 
                                                                        <div className='' key={i}>
                                                                            <img src={v} />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>}
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        )
                                    }
                                    
                                )}
                                <div ref={containerRef}></div>
                                {/*<div className="msg-body">
                                    <ul>
                                        <li className='text-center mb-3'>
                                            <div className='msg-day d-inline-block'>Yesterday</div>
                                        </li>
                                        <li className="sender">
                                            <div className='msg-box'>
                                                <div className='d-flex align-items-center justify-content-between mb-3'>
                                                    <div className='sm-title fw-600'>2022 Porsche 911 S</div>
                                                    <span className='xs-title font-12'>2:55pm</span>
                                                </div>
                                                <div className='d-flex mb-2'>
                                                    <div className='w-40'>
                                                        <div className='xs-title fw-600'><span className='mnw-70 d-inline-block font-16 fw-400'>VIN:</span> ABCD1234567891122</div>
                                                    </div>
                                                    <div className='w-40'>
                                                        <div className='xs-title fw-600'><span className='mnw-70 d-inline-block font-16 fw-400'>Miles:</span> 45,600</div>
                                                    </div>
                                                </div>
                                                <div className='d-flex mb-3'>
                                                    <div className='w-40'>
                                                        <div className='xs-title fw-600'><span className='mnw-70 d-inline-block font-16 fw-400'>Price:</span> $68,000</div>
                                                    </div>
                                                    <div className='w-40'>
                                                        <div className='xs-title fw-600'><span className='mnw-70 d-inline-block font-16 fw-400'>Delivery:</span> Pick up</div>
                                                    </div>
                                                </div>
                                                <p>Car is in mint conditions, 2 keys, Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation. <a href='#'>View Carfax link</a></p>
                                                <div className='mt-3 d-flex align-items-center chat-gallery'>
                                                    <div className='cg-col'>
                                                        <div className='cg-box'>
                                                            <img src={getImages('chat-gallery1.webp')} />
                                                        </div>
                                                    </div>
                                                    <div className='cg-col'>
                                                        <div className='cg-box'>
                                                            <img src={getImages('chat-gallery2.webp')} />
                                                        </div>
                                                    </div>
                                                    <div className='cg-col'>
                                                        <div className='cg-box'>
                                                            <img src={getImages('chat-gallery3.webp')} />
                                                        </div>
                                                    </div>
                                                    <div className='cg-col'>
                                                        <div className='cg-box'>
                                                            <img src={getImages('chat-gallery4.webp')} />
                                                        </div>
                                                    </div>
                                                    <div className='cg-col'>
                                                        <div className='cg-box'>
                                                            <img src={getImages('chat-gallery5.webp')} />
                                                        </div>
                                                    </div>
                                                    <div className='cg-col'>
                                                        <div className='cg-box'>
                                                            <img src={getImages('chat-gallery5.webp')} />
                                                            <div className='cg-count'>10+</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>

                                        <li className="sender">
                                            <div className='msg-box'>
                                                <div className='d-flex align-items-center justify-content-between mb-3'>
                                                    <div className='sm-title fw-600'>2022 Porsche 911 S</div>
                                                    <span className='xs-title font-12'>2:55pm</span>
                                                </div>
                                                <div className='d-flex mb-2'>
                                                    <div className='w-40'>
                                                        <div className='xs-title fw-600'><span className='mnw-70 d-inline-block font-16 fw-400'>VIN:</span> ABCD1234567891122</div>
                                                    </div>
                                                    <div className='w-40'>
                                                        <div className='xs-title fw-600'><span className='mnw-70 d-inline-block font-16 fw-400'>Miles:</span> 45,600</div>
                                                    </div>
                                                </div>
                                                <div className='d-flex mb-3'>
                                                    <div className='w-40'>
                                                        <div className='xs-title fw-600'><span className='mnw-70 d-inline-block font-16 fw-400'>Price:</span> $68,000</div>
                                                    </div>
                                                    <div className='w-40'>
                                                        <div className='xs-title fw-600'><span className='mnw-70 d-inline-block font-16 fw-400'>Delivery:</span> Pick up</div>
                                                    </div>
                                                </div>
                                                <p>Car is in mint conditions, 2 keys, Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation. <a href='#'>View Carfax link</a></p>
                                                <div className='mt-3 d-flex align-items-center chat-gallery'>
                                                    <div className='cg-col'>
                                                        <div className='cg-box'>
                                                            <img src={getImages('chat-gallery1.webp')} />
                                                        </div>
                                                    </div>
                                                    <div className='cg-col'>
                                                        <div className='cg-box'>
                                                            <img src={getImages('chat-gallery2.webp')} />
                                                        </div>
                                                    </div>
                                                    <div className='cg-col'>
                                                        <div className='cg-box'>
                                                            <img src={getImages('chat-gallery3.webp')} />
                                                        </div>
                                                    </div>
                                                    <div className='cg-col'>
                                                        <div className='cg-box'>
                                                            <img src={getImages('chat-gallery4.webp')} />
                                                        </div>
                                                    </div>
                                                    <div className='cg-col'>
                                                        <div className='cg-box'>
                                                            <img src={getImages('chat-gallery5.webp')} />
                                                        </div>
                                                    </div>
                                                    <div className='cg-col'>
                                                        <div className='cg-box'>
                                                            <img src={getImages('chat-gallery5.webp')} />
                                                            <div className='cg-count'>10+</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>*/}
                            </div>
                            <div className='modal-footer d-block position-relative'>
                                <button type='button' className={`chat-toggle-btn ${!openEnterMessage && 'open'} `}  onClick={handleEnterMessage}>
                                    <span className='chat-toggle-text'> {!openEnterMessage ? 'open' : 'Close'}</span>
                                    <span className='chat-arrow-icon'></span>
                                </button>
                                {!openEnterMessage ? 
                                    <div className='text-center'>
                                        <button type='button' className='red-btn m-0 w-280 text-uppercase' onClick={handleEnterMessage}>Enter Message</button>
                                    </div> : 
                                    <SendForm 
                                        handlePhotoUploadModal={handlePhotoUploadModal} 
                                        handleHistoricalOptionsModal={handleHistoricalOptionsModal}
                                        activeChatData={activeChatData}
                                        photoSIDs={photoSIDs}
                                        setPhotoSIDs={setPhotoSIDs}
                                        sendMessage={sendMessage}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </div>}
            </ChatLayout>
            
            <ModalLayout open={openPhotoUploadModal} close={closePhotoUploadModal} modalWidth={1140} darkThemeCls="true">
                <PhotosUpload close={closePhotoUploadModal} photoSIDs={photoSIDs} setPhotoSIDs={setPhotoSIDs} activeChatData={activeChatData}/>
            </ModalLayout>
            <ModalLayout open={openHistoricalOptionsModal} close={closeHistoricalOptionsModal} modalWidth={1140} darkThemeCls="true">
                <HistoricalOptionsModal close={closeHistoricalOptionsModal}/>
            </ModalLayout>
        </>
    );
};

export default Chat;
